<style scoped lang="scss">
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{ 
  .compose-type1 .neirong{
    display: block!important;
  }
  .effect-lists1{
    flex-wrap: wrap;
    justify-content: flex-start!important;
  }
  .required{
    margin-top: 5px!important;
  }
  .compose-type1{
    padding-bottom: 20px!important;
  }
}
@media screen and (min-width: 641px){
  .ismobile{display: none;}
  .effect-lists{
    //display: block!important;
    justify-content: space-between!important;
    flex-wrap:wrap;
    overflow: auto;
  }
}
@media screen and (max-width: 640px){
  .ispc{display: none;}
}
 
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}

.effect-lists li{
  width: 21% !important;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
.compose-type1{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/T载体克隆/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
.cons{
  display: none;
}

.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 850px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
   
    <!-- <div class="banner con">
      <img src="@/assets/img/产品及服务/T载体克隆/banner.png" class="img-fluid">
      <div class="info"></div>
    </div> -->
    <!---移动端-->
    <!-- <div class="banner cons">
      <img src="@/assets/img/二级标题Banner/T载体克隆banner.jpg" class="img-fluid">
      <div class="info"></div>
    </div> -->
    <div class="container container10">
      <h1>甲基化检测（BSP测序）</h1>
      <h2 class="mt10">Methylation Detection (BSP sequencing)</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">        
        <p class="desc" style="margin-bottom: 10px;">亚硫酸氢盐测序法（BisulfiteSequencingPCR，BSP）是甲基化检测的主要
方法。基因组DNA经亚硫酸氢盐处理后，则未发生甲基化的胞嘧啶（C）被转
化为尿嘧啶（U），而发生甲基化的胞嘧啶不变，尿嘧啶（U）在后续的PCR扩
增中会被T替代。根据目的区域序列设计BSP特异性引物进行PCR扩增，扩
增的PCR产物进行TA克隆后测序，从而得到目的区域的甲基化情况。</p>
        </div>
      <div class="container">
        <div class="c-title">服务流程<small>Service process</small></div>
        <img src="@/assets/img/产品及服务/BSP_Sequencing/img1.png" class="img-fluid">
        
      </div>
      <div class="container" style="margin-bottom: 50px;">
        <div class="c-title">送样要求<small>Sample Delivery Requirements</small></div>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">细胞≥10^6个；组织≥200mg；全血≥0.5mL；</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">基因组DNA：浓度>50ng/μL，体积>20μL，总量在500ng以上。</p>        
      </div>
      <div class="container" style="margin-bottom: 50px;">
        <div class="c-title">结果交付<small>Delivery Of Results</small></div>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em"><b>测序峰图：</b>亚硫酸盐处理后片段测序结果</p>  
        <img src="@/assets/img/产品及服务/BSP_Sequencing/img2.png"  class="img-fluid">      
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em"><b>比对结果：</b></p>   
        <img src="@/assets/img/产品及服务/BSP_Sequencing/img3.png" class="img-fluid">            
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em"><b>甲基化圆点图：</b></p> 
        <img src="@/assets/img/产品及服务/BSP_Sequencing/img4.png"  class="img-fluid ispc">  
        <img src="@/assets/img/产品及服务/BSP_Sequencing/img4_mo.png"  class="img-fluid ismobile">      
     
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'DNA提取', img: '1', ref: '/tec/DNA_extraction'},
        {name: 'PCR扩增', img: '2', ref: '/tec/PCR'},
        {name: 'SSR/STR检测', img: '4', ref: '/tec/SSR'},
        {name: 'SNP检测', img: '5', ref: '/tec/SNP'},
        {name: '特定基因检测', img: '6', ref: '/tec/specific'},
        {name: '荧光定量PCR', img: '7', ref: '/tec/qPCR'},
        {name: '菌种鉴定', img: '8', ref: '/tec/rDNA'},
        {name: '细胞系鉴定', img: '9', ref: '/tec/identification'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/BSP_Sequencing.vue